// extracted by mini-css-extract-plugin
export default {"root":"Category-module__[local]___DC-9A"};